export const QUANLYDANHMUC_SET_LIST_DATA = 'QUANLYDANHMUC_SET_LIST_DATA';
export const QUANLYDANHMUC_SET_LIST_META = 'QUANLYDANHMUC_SET_LIST_META';
export const QUANLYDANHMUC_TITLE = 'Quản lý danh mục';